import * as Models from "../Models";
import * as Common from "../Common/modules";

export interface IPaymentCaptureApiClient {
    submitResidentialPaymentCapture: (customerProfile: Models.PaymentCapture.PaymentCaptureCustomer.IResidentialPaymentCaptureCustomer) => ng.IPromise<any>;
    getCommunityList: () => ng.IPromise<any>;
    submitCommunityPaymentCapture: (customerProfile: Models.PaymentCapture.PaymentCaptureCustomer.CommunityPaymentCaptureCustomer) => ng.IPromise<any>;
    getConfirmationInformation: (confirmationRequest: Models.PaymentCapture.PaymentCaptureCustomer.IResidentialPaymentCaptureConfirmationRequest) => ng.IPromise<any>;
    getResidentialPaymentCaptureCustomerInformation: (igsCustomerNumber: Models.PaymentCapture.PaymentCaptureCustomer.IResidentialPaymentCaptureCustomerInformationRequest) => ng.IPromise<any>;
    doesOpportunityAlreadyExist: (opportunityNumber: Models.PaymentCapture.PaymentCaptureCustomer.IResidentialPaymentCaptureCustomer) => ng.IPromise<any>;
}

export class PaymentCaptureApiClient implements IPaymentCaptureApiClient {

    public static $inject = ['igs.apiClientService'];

    constructor(private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {
    }

    public submitResidentialPaymentCapture = (customerProfile: Models.PaymentCapture.PaymentCaptureCustomer.ResidentialPaymentCaptureCustomer): ng.IPromise<any> => {
        return this.igsApiClientService.post("CaptureResidentialCustomerAndPaymentInformation", customerProfile);
    }

    public getResidentialPaymentCaptureCustomerInformation = (request: Models.PaymentCapture.PaymentCaptureCustomer.IResidentialPaymentCaptureCustomerInformationRequest): ng.IPromise<any> => {
        var config = { errorHandler: () => { } };
        return this.igsApiClientService.post("GetResidentialPaymentCaptureCustomerInformation", request, config);
    }

    public getCommunityList = (): ng.IPromise<any> => {
        return this.igsApiClientService.get("GetCommunityList");
    }

    public submitCommunityPaymentCapture = (customerProfile: Models.PaymentCapture.PaymentCaptureCustomer.CommunityPaymentCaptureCustomer): ng.IPromise<any> => {
        return this.igsApiClientService.post("SubmitCommunitySolarPaymentCapture", customerProfile);
    }

    public getConfirmationInformation = (confirmationRequest: Models.PaymentCapture.PaymentCaptureCustomer.IResidentialPaymentCaptureConfirmationRequest): ng.IPromise<any> => {
        return this.igsApiClientService.post("GetConfirmationInformation", confirmationRequest);
    }

    public doesOpportunityAlreadyExist = (opportunityNumber: Models.PaymentCapture.PaymentCaptureCustomer.ResidentialPaymentCaptureCustomer): ng.IPromise<any> => {
        return this.igsApiClientService.post("DoesOpportunityExist", opportunityNumber);
    }
}
